import React from "react";

import { Bet } from "@models";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

export const HandlingFeePercentage = observer(
	function HandlingFeePercentage(props: { bet: Bet }) {
		const { bet } = props;

		const { t } = useTranslation("mybets");

		if (!bet.handlingFee && bet.handlingFeePercentage == 0) {
			return null;
		}
		return (
			<div className="bet__details__row">
				<div className="bet__details__col">
					{t("ITEM.ADDITIONAL_HANDLING_FEE", {
						0: bet.handlingFeePercentage?.toFixed(),
					})}
				</div>
				<div className="bet__details__col">
					{bet.displayHandlingFee}
				</div>
			</div>
		);
	}
);
